'use strict';

var novicell = novicell || {};

novicell.imageViewMaximized = novicell.imageViewMaximized || new function () {

    var triggers = document.querySelectorAll('.js-image-overlay-trigger');
    
    for(var i = 0; i < triggers.length; i++)
    {
        const trigger = triggers[i];
        trigger.addEventListener('click', function(e) {
            e.preventDefault();
    
            // var trigger = e.currentTarget;
            var elem = document.createElement('div');
            var img = document.createElement('img');
    
            img.src = trigger.getAttribute('data-element');
            elem.appendChild(img);
    
            novicell.overlay.create({
                'element': elem,
                'class': 'image-download-block__overlay'
            });
        });
    }
}();